import { select, call, put } from 'redux-saga/effects';
import { getProvisionalAgreement as getProvisionalAgreementAda } from '@bitComponents/adabyron/cqv2';
import { WEB_SERVICES } from './webServices';

const contextStore = state => state.context.data;

export function* getProvisionalAgreement(params) {
  const {
    reduxUpdate,
    cqId,
    normalizeHttpErrors,
  } = params;
  try {
    const { successUpdate } = reduxUpdate;
    const context = yield select(contextStore);
    const response = yield call(getProvisionalAgreementAda, { cqId }, context);
    yield put(successUpdate(response));
    return response;
  } catch (error) {
    const { errorUpdate } = reduxUpdate;
    const errorNormalized = yield call(normalizeHttpErrors, WEB_SERVICES.GET_PROVISIONAL_AGREEMENT, error);
    if (errorUpdate) {
      yield put(errorUpdate(errorNormalized));
    }

    throw error;
  }
}
